module.exports = __webpack_public_path__ + "static/media/RS.ffbc0b43.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/RS.svg
// module id = 348
// module chunks = 0